<template>
  <section id="add-user-block" v-loading="loading" class="case-creation">
    <div class="container-default">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card mb-10">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">
                {{ isNewUser ? "Add User" : "Update User" }}
              </h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <div
              class="vue-form"
              v-loading.fullscreen="loading"
              :element-loading-text="loadingText"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <el-form ref="form" v-model="formData">
                <el-row :gutter="20">
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          User Type
                          <span class="star">*</span>
                        </label>
                        <el-select
                          placeholder="Select User Type"
                          v-model="formData.user_type"
                          filterable
                          default-first-option
                        >
                          <el-option
                            v-for="item in userTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <p
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.user_type
                          "
                        >
                          {{ getUserAccountErrors.user_type }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="11">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Labs
                          <span class="star">*</span>
                        </label>
                        <el-select
                          v-model="formData.facilities"
                          placeholder="Select Labs"
                          :filterable="true"
                          default-first-option
                          multiple
                        >
                          <el-option
                            v-for="(lab, index) of getAllLabs"
                            :key="index"
                            :value="lab._id"
                            :label="lab.name"
                          ></el-option>
                        </el-select>
                        <p
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.lab
                          "
                        >
                          {{ getUserAccountErrors.lab }}
                        </p>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row
                  :gutter="20"
                  v-show="formData.user_type"
                >
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          First Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          v-model="formData.first_name"
                          placeholder="Enter First Name"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.first_name
                          "
                          >{{ this.getUserAccountErrors.first_name }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Last Name
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          v-model="formData.last_name"
                          placeholder="Enter Last Name"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.last_name
                          "
                          >{{ this.getUserAccountErrors.last_name }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4" v-if="!userId">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Email
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="email"
                          class="email-lower"
                          v-model="formData.email"
                          placeholder="Enter Email"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.email
                          "
                          >{{ this.getUserAccountErrors.email }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4" v-if="!userId">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Username
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="text"
                          class="email-lower"
                          v-model="formData.username"
                          placeholder="Enter Username"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.username
                          "
                          >{{ this.getUserAccountErrors.username }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="4" v-if="formData.user_type == 'LAB_PHYSICIAN'">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          NPI
                          <span class="star">*</span>
                        </label>
                        <el-input
                          type="npi"
                          class="email-lower"
                          v-model="formData.npi"
                          placeholder="Enter NPI"
                          maxlength="10"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.npi
                          "
                          >{{ this.getUserAccountErrors.npi }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div>
            <el-row
              class="borderBotton"
              :gutter="20"
              v-show="formData.user_type"
            >
              <el-col>
                <div
                  class="case-creation__actions"
                  style="
                    display: flex;
                    justify-content: flex-end;
                    padding: 10px 10px 10px 0;
                  "
                >
                  <ul class="list pb-0 pt-0">
                    <li>
                      <el-button
                        size="medium"
                        type="default"
                        class="btn cancel-button"
                        @click="cancelUser()"
                        >Cancel</el-button
                      >
                    </li>
                    <li>
                      <el-button
                        size="medium"
                        type="success"
                        class="btn save-button"
                        @click="onSubmit"
                      >
                        {{ isNewUser ? "Add Account" : "Update Account" }}
                      </el-button>
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "profile",
  mixins: [UserPermissionsHelper, AppHelper, caseDataHelper],
  computed: {
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("userAccounts", [
      "getUserAccountAddStatus",
      "getUserAccountUpdateStatus",
      "getUserAccountErrors",
      "getEmailNotification",
      "getUserAccountDataById",
      "getAllUsers",
    ]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("profile", ["getProfileDesignationForHeader"]),
  },
  data() {
    return {
      loading: false,
      isNewUser: true,
      userId: "",
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        username: "",
        user_type: "",
        facilities: [],
        password:"",
        npi:""
      },
      userTypes: [
        { value: "BILLING_REPRESENTATIVE", label: "Billing Representative" },
        { value: "LAB_ADMIN", label: "Lab Admin" },
        { value: "LAB_PHYSICIAN", label: "Lab Physician" },
      ],
      disableUserAdd: false,
      loadingText: "",
    };
  },
  async mounted() {
    this.userId = this.$route.params.user_id;
    await this.checkAndFetchUser();
    this.refreshErrors();
  },
  methods: {
    cancelUser() {
      if (this.$route.query && this.$route.query.redirectRoute) {
        this.$router.push({
          name: "userAccounts",
          path: "/user-accounts",
          query: this.$route.query,
        });
      } else {
        this.$router.push({
          name: "userAccounts",
          path: "/user-accounts",
        });
      }
    },
    async checkAndFetchUser() {
      try {
        if (this.userId) {
          this.loading = true;
          this.isNewUser = false;
          this.loadingText = "Fetching data.........";

          await this.$store.dispatch("userAccounts/fetchUserAccountById", {
            id: this.userId,
          });
          let data = { ...this.getUserAccountDataById };
          if (data) {
            this.setUserDetailsInForm(data);
          }
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async refreshErrors() {
      await this.$store.dispatch("userAccounts/refreshErrors");
    },
    async fetchLabs() {
      try {
        await this.$store.dispatch("labs/fetchAllLabs", {
          get_all: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit() {
      if (this.isNewUser) {
        await this.addAccount();
      } else {
        await this.updateAccount();
      }
    },
    prepareParams() {
      let params = {
        first_name: this.formData.first_name.trim(),
        last_name: this.formData.last_name.trim(),
        email: this.formData.email ? this.formData.email.toLowerCase() : "",
        user_type: this.formData.user_type,
        facilities: this.formData.facilities,
        password: this.formData.password,
        npi: this.formData.npi,
        username: this.formData.username,
      }
      return params;
    },
    async addAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = this.prepareParams();
        params = this.getFormattedValues(params);

        await this.$store.dispatch("userAccounts/addUserAccount", params);
        this.loading = false;
        this.disableUserAdd = false;

        if (this.getUserAccountAddStatus) {
          successNotification("User Account added successfully");
          this.cancelUser();
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        this.loading = false;
        this.disableUserAdd = false;
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error at Adding user account",
        });
      }
    },
    async updateAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = {
          first_name: this.formData.first_name.trim(),
          last_name: this.formData.last_name.trim(),
          user_type: this.formData.user_type,
          facilities: this.formData.facilities,
          npi: this.formData.npi,
        };
        if (this.userId) {
          params.id = this.userId;
        }
        params = this.getFormattedValues(params);

        await this.$store.dispatch("userAccounts/updateUserAccount", params);
        this.loading = false;
        this.disableUserAdd = false;
        if (this.getUserAccountUpdateStatus) {
          successNotification("User Account updated successfully");
          this.cancelUser();
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        this.loading = false;
        this.disableUserAdd = false;
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error at Updating user account",
        });
      }
    },
    async setUserDetailsInForm(data) {
      this.formData.first_name = data.first_name;
      this.formData.last_name = data.last_name;
      this.formData.email = data.email;
      this.formData.lab = data.lab ? data.lab._id : "";
      this.formData.facilities = data.facilities ? data.facilities : "";
      this.formData.user_type = data.user_type;
      this.formData.npi = data.npi;
    },
  },
};
</script>

<style lang="scss">
#add-user-block {
  .email-events {
    display: flex;
    align-items: center;
    position: relative;
    padding: 0.5rem 1rem;
    .email-label {
      padding-right: 10px;
      color: #0a5da6;
      font-size: 15px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
    .check-box-group {
      .search-checkbox {
        margin-left: 23px;
        .el-checkbox {
          height: 35px;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
          width: 17px;
          height: 17px;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #0a5da6;
          border-color: #ffffff;
          width: 17px;
          height: 17px;
          box-shadow: 0 0 0 1px #ced1d6;
        }

        .el-checkbox__label {
          color: #34495e;
        }
      }
      .el-checkbox__inner::after {
        box-sizing: content-box;
        content: "";
        border: 2px solid var(--el-checkbox-checked-icon-color);
        border-left: 0;
        border-top: 0;
        height: 9px;
        left: 5.5px;
        position: absolute;
        top: 1px;
        transform: rotate(45deg) scaleY(1);
        width: 3px;
        transition: transform 0.15s ease-in 50ms;
        transform-origin: center;
      }
    }
  }
  .borderBotton {
    border-top: 1px solid #e7e7f7;
    align-items: center;
  }
  .gridAuto {
    display: flex;
    // grid-template-columns: 1fr 2fr;
  }
  .selectedFacilities {
    border: 1.2px solid #e7e7f7;
    border-radius: 6px;
    overflow: hidden;
    .selectedHeader {
      background-color: #e7e7f7;
      color: #273480;
      text-transform: uppercase;
      padding: 0.3rem 1rem;
      font-size: 15px;
    }
    .cardBody {
      padding: 0.5rem 1rem;
      ul,
      .selectedCheckBox {
        height: 300px;
        overflow: auto;
        margin-top: 0.5rem;
        @media (min-width: 1280px) and (max-width: 1600px) {
          height: 160px;
        }
      }
      .search-filter {
        min-height: 33.5px;
        max-height: 33px;
        background: #ffffff;
        border: 0.5px solid #e0e0e0;
        border-radius: 4px;
        min-width: 90%;
        color: #000000;
        padding: 0 10px;
        line-height: 1;
        display: flex;
        align-items: center;

        input {
          min-height: 24px;
          max-height: 32px;
          border: none;
          padding: 0;
          color: #000000;
        }

        .icon {
          width: 22px;
          margin-left: 0.5em;
          line-height: 1;
          margin-bottom: -3px;
        }
      }
      .checkBoxAlignment {
        display: flex;
        align-items: center;
        img {
          position: relative;
          top: 1px;
          left: 5px;
          height: 16px;
          width: 16px;
        }
      }
      .search-checkbox {
        margin-left: 3px;
        margin-bottom: 0;
        position: relative;
        top: 3px;
        width: 90%;
        height: 26px;

        .el-checkbox {
          height: 22px;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
          width: 17px;
          height: 17px;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #0a5da6;
          border-color: #ffffff;
          box-shadow: 0 0 0 1px #ced1d6;
          width: 17px;
          height: 17px;
        }

        .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          border: 2px solid var(--el-checkbox-checked-icon-color);
          border-left: 0;
          border-top: 0;
          height: 9px;
          left: 5px;
          border-radius: 1px;
          position: absolute;
          top: 1px;
          transform: rotate(45deg) scaleY(1);
          width: 3px;
          transition: transform 0.15s ease-in 50ms;
          transform-origin: center;
        }

        .el-checkbox__label {
          color: #34495e;
          font-size: 12px;
        }
      }
    }
  }
  .username {
    .el-input__inner {
      text-transform: lowercase !important;
    }
  }
}
</style>